var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "v-row",
            { staticClass: "mobile-scroll" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", lg: "4" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "justify-space-between soli-grey" },
                            [
                              _vm._v(
                                "\n                            Login Details\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "flex justify-center" },
                                    [
                                      _c(
                                        "v-avatar",
                                        {
                                          staticClass: "shadow-blue",
                                          attrs: {
                                            size: _vm.user.profile_photo_path
                                              ? 200
                                              : 125,
                                          },
                                        },
                                        [
                                          _c("v-img", {
                                            attrs: {
                                              src: _vm.hasPhoto
                                                ? `/api/image-service/200x200/${_vm.user.profile_photo_path}`
                                                : _vm.user.profile_photo_url,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        ref: "photo",
                                        staticClass: "hidden",
                                        attrs: { type: "file" },
                                        on: {
                                          input: function ($event) {
                                            return _vm.convertPhoto($event)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.photo
                                    ? _c(
                                        "v-row",
                                        {
                                          staticClass:
                                            "justify-center w-full my-1",
                                        },
                                        [
                                          _c(
                                            "small",
                                            { staticClass: "red--text" },
                                            [_vm._v(_vm._s(_vm.errors.photo))]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.relationshipsAndMe ||
                                  _vm.can("Edit profile photos")
                                    ? _c(
                                        "v-row",
                                        {
                                          class: ["my-3 justify-center w-full"],
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              class: [
                                                "soli-round",
                                                _vm.hasPhoto ? "ml-3.5" : null,
                                              ],
                                              attrs: {
                                                text: "",
                                                small: "",
                                                plain: "",
                                                color: "dark",
                                                type: "button",
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.selectNewPhoto.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.hasPhoto
                                                    ? "Edit Photo"
                                                    : "Add Photo"
                                                ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.hasPhoto,
                                                  expression: "hasPhoto",
                                                },
                                              ],
                                              staticClass: "soli-grey-text",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        |\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.hasPhoto
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass: "soli-round",
                                                  attrs: {
                                                    small: "",
                                                    plain: "",
                                                    text: "",
                                                    color: "dark",
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.deletePhoto.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Delete Photo\n                                    "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("SoliText", {
                                        attrs: {
                                          errors: _vm.errors.email,
                                          rules: !_vm.user.loginable
                                            ? []
                                            : _vm.rules.email,
                                          icon: "alternate_email",
                                          label: "Email",
                                        },
                                        model: {
                                          value: _vm.form.email,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "email", $$v)
                                          },
                                          expression: "form.email",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.$page.props.staffView &&
                                      _vm.can("Manage user locations")
                                        ? _c("SoliUserLocation", {
                                            attrs: {
                                              locations:
                                                _vm.$page.props.auth.user
                                                  .locations,
                                              rules: _vm.rules.input,
                                              multiple: "",
                                              idOnly: "",
                                            },
                                            model: {
                                              value: _vm.form.locations,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "locations",
                                                  $$v
                                                )
                                              },
                                              expression: "form.locations",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.user.hasRoles.includes("Teacher")
                                        ? _c("v-text-field", {
                                            staticClass: "soli-round",
                                            attrs: {
                                              rules: _vm.validUrl,
                                              dense: "",
                                              "validate-on-blur": "",
                                              outlined: "",
                                              "prepend-inner-icon": "videocam",
                                              label: "Online Meeting Link",
                                              placeholder: "https://",
                                            },
                                            model: {
                                              value: _vm.form.zoom_url,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "zoom_url",
                                                  $$v
                                                )
                                              },
                                              expression: "form.zoom_url",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.user.email &&
                                      _vm.$page.props.staffView &&
                                      _vm.can("Manage logins")
                                        ? _c("v-switch", {
                                            staticClass: "mt-0 mx-1",
                                            attrs: {
                                              dense: "",
                                              label: "Active Login",
                                            },
                                            on: {
                                              change: function ($event) {
                                                !$event && _vm.user.loginable
                                                  ? (_vm.confirmActiveUser = true)
                                                  : null
                                              },
                                            },
                                            model: {
                                              value: _vm.form.loginable,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "loginable",
                                                  $$v
                                                )
                                              },
                                              expression: "form.loginable",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.choicePassword &&
                                      _vm.$page.props.auth.user.email ==
                                        _vm.user.email
                                        ? _c("SoliForm", {
                                            ref: "soliForm",
                                            attrs: {
                                              text: "Save",
                                              icon: "save",
                                              title: "Update Password",
                                              textSubtitle:
                                                "Ensure your account is using a long, random password to stay secure.",
                                            },
                                            on: {
                                              reset: function ($event) {
                                                ;[(_vm.choicePassword = false)]
                                              },
                                              submit: _vm.updatePassword,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "body",
                                                  fn: function () {
                                                    return [
                                                      _c("SoliText", {
                                                        attrs: {
                                                          name: "current-password",
                                                          errors:
                                                            _vm.passwordForm
                                                              .errors
                                                              .current_password,
                                                          rules:
                                                            _vm.rules.input,
                                                          label:
                                                            "Current Password",
                                                          required: "",
                                                          password: true,
                                                          show: _vm.show,
                                                        },
                                                        on: {
                                                          append: function (
                                                            $event
                                                          ) {
                                                            _vm.show = !_vm.show
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.passwordForm
                                                              .current_password,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.passwordForm,
                                                              "current_password",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "\n                                                    passwordForm.current_password\n                                                ",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("SoliText", {
                                                        attrs: {
                                                          name: "password",
                                                          errors:
                                                            _vm.passwordForm
                                                              .errors.password,
                                                          rules:
                                                            _vm.rules.input,
                                                          label: "New Password",
                                                          required: "",
                                                          password: true,
                                                          show: _vm.show,
                                                        },
                                                        on: {
                                                          append: function (
                                                            $event
                                                          ) {
                                                            _vm.show = !_vm.show
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.passwordForm
                                                              .password,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.passwordForm,
                                                              "password",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "\n                                                    passwordForm.password\n                                                ",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("SoliText", {
                                                        attrs: {
                                                          name: "password_confirmation",
                                                          errors:
                                                            _vm.passwordForm
                                                              .errors
                                                              .password_confirmation,
                                                          rules:
                                                            _vm.rules.input,
                                                          label:
                                                            "Confirm Password",
                                                          required: "",
                                                          password: true,
                                                          show: _vm.show,
                                                        },
                                                        on: {
                                                          append: function (
                                                            $event
                                                          ) {
                                                            _vm.show = !_vm.show
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.passwordForm
                                                              .password_confirmation,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.passwordForm,
                                                              "password_confirmation",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "\n                                                    passwordForm.password_confirmation\n                                                ",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              3187957682
                                            ),
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "flex justify-end" },
                                        [
                                          _vm.can("Delete users")
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    plain: "",
                                                    small: "",
                                                    rounded: "",
                                                    color: "error",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.confirmDelete = true
                                                    },
                                                  },
                                                },
                                                [_vm._v("Remove")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$page.props.auth.user.id ==
                                            _vm.user.id ||
                                          _vm.can("Reset passwords")
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "accent",
                                                    plain: "",
                                                    small: "",
                                                    rounded: "",
                                                    disabled:
                                                      _vm.editing ||
                                                      !_vm.user.email ||
                                                      !_vm.user.loginable,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.choicePassword = true
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            Reset Password\n                                        "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", lg: "4" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c("v-card-title", { staticClass: "soli-grey" }, [
                            _vm._v(
                              "\n                            User Info\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pb-0" },
                                    [
                                      _c("SoliText", {
                                        attrs: {
                                          errors: _vm.errors.first_name,
                                          rules: _vm.rules.input,
                                          icon: "person",
                                          label: "First Name",
                                        },
                                        model: {
                                          value: _vm.form.first_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "first_name",
                                              $$v
                                            )
                                          },
                                          expression: "form.first_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { staticClass: "pb-0" },
                                    [
                                      _c("SoliText", {
                                        attrs: {
                                          errors: _vm.errors.last_name,
                                          rules: _vm.rules.input,
                                          label: "Last Name",
                                        },
                                        model: {
                                          value: _vm.form.last_name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "last_name", $$v)
                                          },
                                          expression: "form.last_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "py-0" },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: [
                                            "She/her",
                                            "He/his",
                                            "She/they",
                                            "He/they",
                                            "They/their",
                                            "Other",
                                          ],
                                          label: "Pronouns",
                                          "prepend-inner-icon": "all_inclusive",
                                          outlined: "",
                                          dense: "",
                                        },
                                        model: {
                                          value: _vm.form.pronouns,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "pronouns", $$v)
                                          },
                                          expression: "form.pronouns",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("SoliText", {
                                        ref: "phone",
                                        attrs: {
                                          icon: "phone",
                                          label: "Phone",
                                          placeholder: "10-digits",
                                          errors: _vm.errors.phone,
                                          rules: _vm.rules.phoneNotRequired,
                                          phone: "",
                                        },
                                        on: { input: _vm.maskPhone },
                                        model: {
                                          value: _vm.form.phone,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "phone", $$v)
                                          },
                                          expression: "form.phone",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.viewSensitiveData
                                        ? _c("SoliDate", {
                                            attrs: {
                                              clearable: "",
                                              label: "Birthday",
                                              errors: _vm.errors.input,
                                              rules: [],
                                              icon: "cake",
                                              birthday: "",
                                            },
                                            on: {
                                              clear: function ($event) {
                                                _vm.form.birthday = null
                                              },
                                            },
                                            model: {
                                              value: _vm.form.birthday,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "birthday",
                                                  $$v
                                                )
                                              },
                                              expression: "form.birthday",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewSensitiveData
                                        ? _c("SoliAddress", {
                                            attrs: {
                                              errors: _vm.errors.address,
                                              rules:
                                                _vm.$page.props.staffView ||
                                                !_vm.user.email
                                                  ? []
                                                  : _vm.rules.input,
                                              address: _vm.user.address,
                                              city: _vm.user.city,
                                            },
                                            on: {
                                              setAddress: function ($event) {
                                                ;[
                                                  (_vm.form.address =
                                                    $event.address),
                                                  (_vm.form.city = $event.city),
                                                ]
                                              },
                                            },
                                            model: {
                                              value: _vm.form.address,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "address",
                                                  $$v
                                                )
                                              },
                                              expression: "form.address",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewSensitiveData
                                        ? _c("SoliText", {
                                            ref: "zip",
                                            attrs: {
                                              icon: "location_city",
                                              label: "Zip Code",
                                              errors: _vm.errors.zip_code,
                                              rules:
                                                _vm.can(
                                                  "Manage user locations"
                                                ) && _vm.$page.props.staffView
                                                  ? _vm.rules.zipCodeNotRequired
                                                  : _vm.rules.zipCode,
                                              zipCode: "",
                                            },
                                            model: {
                                              value: _vm.form.zip_code,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "zip_code",
                                                  $$v
                                                )
                                              },
                                              expression: "form.zip_code",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewSensitiveData
                                        ? _c("SoliText", {
                                            ref: "apartment",
                                            attrs: {
                                              icon: "apartment",
                                              label: "Apartment",
                                              errors: _vm.errors.apartment,
                                            },
                                            model: {
                                              value: _vm.form.apartment,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "apartment",
                                                  $$v
                                                )
                                              },
                                              expression: "form.apartment",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isTeacher
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", lg: "4" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-card-title",
                                [
                                  _vm._v("Teacher Biography"),
                                  !_vm.user.bio?.content?.length
                                    ? _c(
                                        "v-icon",
                                        {
                                          attrs: { right: "", color: "error" },
                                        },
                                        [_vm._v("error_outline")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.form.bio?.length
                                ? _c(
                                    "v-card-subtitle",
                                    { staticClass: "pb-1" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          `Last Updated ${_vm.globalMomentFullDateAtTime(
                                            _vm.user.bio?.updated_at
                                          )}`
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-card-subtitle",
                                { staticClass: "pt-0 px-3" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "soli-round soli-blue-text",
                                      attrs: {
                                        "x-small": "",
                                        outlined: "",
                                        disabled:
                                          _vm.summarizeLoading ||
                                          !!_vm.user.bio?.content?.length,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.showBioHelpForm = true
                                        },
                                      },
                                    },
                                    [_vm._v("Help Getting Started")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "soli-round soli-blue-text",
                                      attrs: {
                                        disabled:
                                          !_vm.form.bio?.length ||
                                          _vm.form.bio?.length <= 750,
                                        "x-small": "",
                                        outlined: "",
                                        loading: _vm.summarizeLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.helpSummarize()
                                        },
                                      },
                                    },
                                    [_vm._v("Help Summarizing")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-textarea", {
                                staticClass: "soli-round px-3",
                                attrs: {
                                  placeholder: `Brief description of ${_vm.user.first_name}'s experience as a musician and educator.`,
                                  outlined: "",
                                  dense: "",
                                  autoGrow: "",
                                  rules: [
                                    (v) =>
                                      (v || "").length <= 750 ||
                                      `Character limit reached`,
                                  ],
                                },
                                model: {
                                  value: _vm.form.bio,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "bio", $$v)
                                  },
                                  expression: "form.bio",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.choicePassword &&
      _vm.can("Reset passwords") &&
      _vm.$page.props.auth.user.id !== _vm.user.id
        ? _c("SoliChoice", {
            attrs: {
              title: "Update Password",
              subtitle: `Send password reset link to ${_vm.user.email}?`,
              button1: "Send Link!",
              button2: "Nevermind",
            },
            on: {
              option1: _vm.requestPassword,
              reset: function ($event) {
                _vm.choicePassword = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmActiveUser
        ? _c("SoliChoice", {
            attrs: {
              title: "Are you sure?",
              subtitle: `${_vm.user.first_name}'s login will be deactivated, removing access to our software. This will not delete the account.`,
              button1: "Continue",
              button2: "Nevermind",
              permanent: "",
            },
            on: {
              option2: function ($event) {
                _vm.form.loginable = _vm.user.loginable
              },
              reset: function ($event) {
                _vm.confirmActiveUser = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmDelete
        ? _c("SoliResponsiveDialog", {
            ref: "deleteForm",
            attrs: {
              title: "Delete User",
              subtitle:
                _vm.deleteForm.option?.warning ??
                "How would you like to proceed?",
              warning: "",
              button1: "Confirm",
              button2: "Nevermind",
            },
            on: {
              reset: function ($event) {
                _vm.confirmDelete = false
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.deleteForm.option.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-4 pa-2" },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.deleteOptions,
                                  outlined: "",
                                  dense: "",
                                  "return-object": "",
                                  "hide-details": "auto",
                                  "prepend-inner-icon": "delete",
                                  label: "Select Method",
                                  rules: _vm.rules.select,
                                },
                                model: {
                                  value: _vm.deleteForm.option,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.deleteForm, "option", $$v)
                                  },
                                  expression: "deleteForm.option",
                                },
                              }),
                              _vm._v(" "),
                              _vm.deleteForm.option?.clientSelect
                                ? _c("SoliStudents", {
                                    attrs: {
                                      rules: _vm.deleteForm.option?.clientSelect
                                        ? _vm.rules.select
                                        : [],
                                    },
                                    model: {
                                      value: _vm.deleteForm.user,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.deleteForm, "user", $$v)
                                      },
                                      expression: "deleteForm.user",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-divider"),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        { staticClass: "pb-0" },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "soli-grey",
                              attrs: { text: "", rounded: "" },
                              on: {
                                click: function ($event) {
                                  _vm.$refs.deleteForm.show = false
                                },
                              },
                            },
                            [_vm._v("Nevermind")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "error",
                                text: "",
                                rounded: "",
                                loading: _vm.deleteForm.loading,
                                disabled: !_vm.deleteForm.option,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteForm.option.method()
                                },
                              },
                            },
                            [_vm._v("Confirm")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1980505995
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          staticClass: "soli-round",
          attrs: { "max-width": "425" },
          model: {
            value: _vm.showImageEditor,
            callback: function ($$v) {
              _vm.showImageEditor = $$v
            },
            expression: "showImageEditor",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "soli-round", staticStyle: { overflow: "hidden" } },
            [
              _vm.cropperLoading
                ? _c(
                    "v-container",
                    [
                      _c("v-skeleton-loader", {
                        staticClass: "soli-round",
                        attrs: { type: "image" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("VueCropper", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.cropperLoading,
                    expression: "!cropperLoading",
                  },
                ],
                ref: "cropper",
                attrs: { src: null, aspectRatio: 1, alt: "Loading" },
              }),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        plain: "",
                        color: "soli-grey soli-round",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.closeModal(() => (_vm.showImageEditor = false))
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "soli-blue white--text soli-round",
                      attrs: { loading: _vm.imageLoading },
                      on: {
                        click: function ($event) {
                          _vm.updatePhoto(),
                            _vm.closeModal(() => (_vm.showImageEditor = false))
                        },
                      },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showBioHelpForm
        ? _c("SoliForm", {
            ref: "bioHelpForm",
            attrs: {
              title: "Help Me Write A Biography",
              textSubtitle:
                "I'm not a perfect robot, but I can get you started.",
              persistent: "",
            },
            on: {
              submit: function ($event) {
                return _vm.helpCompose()
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.showBioHelpForm = false))
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("SoliText", {
                        attrs: {
                          label: "List any degrees and where they're from",
                        },
                        model: {
                          value: _vm.bioHelpForm.degrees,
                          callback: function ($$v) {
                            _vm.$set(_vm.bioHelpForm, "degrees", $$v)
                          },
                          expression: "bioHelpForm.degrees",
                        },
                      }),
                      _vm._v(" "),
                      _c("SoliText", {
                        attrs: {
                          label: "How long have you been teaching music?",
                        },
                        model: {
                          value: _vm.bioHelpForm.experience,
                          callback: function ($$v) {
                            _vm.$set(_vm.bioHelpForm, "experience", $$v)
                          },
                          expression: "bioHelpForm.experience",
                        },
                      }),
                      _vm._v(" "),
                      _c("SoliText", {
                        attrs: {
                          label:
                            "Where do you perform and with who? Highlights only!",
                        },
                        model: {
                          value: _vm.bioHelpForm.perform,
                          callback: function ($$v) {
                            _vm.$set(_vm.bioHelpForm, "perform", $$v)
                          },
                          expression: "bioHelpForm.perform",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-textarea", {
                        staticClass: "soli-round",
                        attrs: {
                          "hide-details": "",
                          outlined: "",
                          "auto-grow": "",
                          flat: "",
                          label:
                            "What is unique about your experience or teaching?",
                        },
                        model: {
                          value: _vm.bioHelpForm.about,
                          callback: function ($$v) {
                            _vm.$set(_vm.bioHelpForm, "about", $$v)
                          },
                          expression: "bioHelpForm.about",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              796957909
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }